<template>
  <div class="container">
    <Title :title="route"></Title>
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">
      <el-divider content-position="left">申述申请单</el-divider>
        <el-form-item label="申述类型" prop="purchaseType">
          <el-radio-group v-model="ruleForm.allegeType">
            <el-radio label="3">请假</el-radio>
            <el-radio label="4">外出</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证明文件" prop="file">
          <el-upload
            ref="up"
            action=""
            :file-list="fileList"
            list-type="picture-card"
            accept=".jpg, .jpeg, .png"
            :http-request="httpRequest"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleFileChange">
            <i class="el-icon-plus"></i>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg图片文件，且不超过10M</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="申述说明" prop="remark">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="disabled" type="primary" @click="submit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import {requestAllegeApply, requestApplyDetail} from "@/api";
export default {
  components: {Title},
  data() {
    return {
      route: {
        name: '考勤申述',
        path: '/item/allege'
      },
      disabled: false,
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      ruleForm: {
        recordId: "",
        applyServiceId: "",
        applyType: "",
        allegeType: "3",
        remark: "",
        file: ""
      },
      rules: {
        remark: [
          {required: true, message: '请填写申述说明', trigger: 'blur'}
        ],
        file: [
          {required: true, message: '请上传证明文件', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.param = {
      applyId: this.$route.query.applyId,
      applyServiceId: this.$route.query.applyServiceId,
      applyType: this.$route.query.applyType
    }
    if (this.param.applyId || this.param.applyServiceId || this.param.applyType) {
      this.reapply = true
    }
    this.getObject()
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    async submit() {
      const isPass = await this.$refs['ruleForm'].validate()
      if (isPass) {
        this.disabled = true
        let formData = new FormData()
        formData.append("allegeType", this.ruleForm.allegeType)
        formData.append("remark", this.ruleForm.remark)
        if (this.fileList.length === 0) {
          this.$message.error("请上传证明文件")
          return
        }
        const size = 1024 * 1024 * 10
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].size > size) {
            this.$message.error("文件大小不能超过10MB")
            this.disabled = false
            return
          }
          formData.append("files", this.fileList[i].raw)
        }
        if (this.reapply) {
          formData.append("applyId", this.param.applyId)
        }
        const res = await requestAllegeApply(formData)
        if (res.code === 200) {
          this.$refs['up'].clearFiles()
          this.$refs['ruleForm'].resetFields()
          this.$message.success(res.msg)
          if (this.reapply) {
            await this.$router.push({query: {}})
            this.reapply = false
          }
        } else {
          this.$message.error(res.msg)
        }
        this.disabled = false
      }
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        for (let key in res.object.detail) {
          this.ruleForm[key] = res.object.detail[key]
        }
      }
    },
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.ruleForm.file = ""
      }
      this.fileList = fileList
    },
    handleFileChange(file) {
      this.fileList.push(file)
      this.ruleForm.file = "file"
    },
  }
}
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
  background-color: #F2F6FC;
}
</style>